import { ApiV1_Establishment } from '@pedix-workspace/api-v1';
import {
  EndOrderDetails,
  ShippingEstimate,
  ShippingEstimateRequest,
  ShippingItem,
  transformCartItemsToShippingItems,
} from '@pedix-workspace/utils';

export async function fetchShippingEstimates(
  apiBaseUrl: string,
  establishment: ApiV1_Establishment,
  endOrderDetails: Pick<EndOrderDetails, 'cartItems' | 'personalInformation'>,
): Promise<ShippingEstimate[]> {
  const apiUrl = `${apiBaseUrl}/shipping/calculate`;
  const shippingEstimateRequest = transformToShippingEstimateRequest(
    establishment,
    endOrderDetails,
  );

  return fetch(apiUrl, {
    method: 'POST',
    body: JSON.stringify(shippingEstimateRequest),
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(response => response.data)
    .catch(error => {
      console.error(error);

      return [];
    });
}

export async function fetchParcelShippingEstimates(
  apiBaseUrl: string,
  establishment: ApiV1_Establishment,
  endOrderDetails: Pick<EndOrderDetails, 'cartItems' | 'personalInformation'>,
): Promise<ShippingEstimate[]> {
  const apiUrl = `${apiBaseUrl}/shipping/calculate-parcel`;
  const shippingEstimateRequest = transformToShippingEstimateRequest(
    establishment,
    endOrderDetails,
  );

  return fetch(apiUrl, {
    method: 'POST',
    body: JSON.stringify(shippingEstimateRequest),
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(response => {
      if (!response.data || response.data.length === 0) {
        return [
          {
            outOfDeliveryZone: true,
            error: 'No hay proveedores de envío por paquetería disponibles',
            price: 0,
            estimatedTimeInDays: 0,
            providerName: 'Sin proveedores',
          },
        ];
      }
      return response.data;
    })
    .catch(error => {
      console.error(error);

      return [];
    });
}

function transformToShippingEstimateRequest(
  establishment: ApiV1_Establishment,
  endOrderDetails: Pick<EndOrderDetails, 'cartItems' | 'personalInformation'>,
): ShippingEstimateRequest {
  let shippingItems: ShippingItem[] = transformCartItemsToShippingItems(endOrderDetails.cartItems);

  const totalValue = shippingItems.reduce((acc, item) => acc + item.quantity * item.value, 0);

  return {
    establishmentId: establishment.id,
    items: shippingItems,
    pickup: {
      name: establishment.name,
      phone: establishment.phone,
      address: {
        addressDetails: establishment.addressDetails,
        references: establishment.addressReferences,
      },
    },
    delivery: {
      name: endOrderDetails.personalInformation?.name,
      phone: endOrderDetails.personalInformation?.phone,
      address: endOrderDetails.personalInformation?.address,
    },
    total: totalValue,
    currencyCode: establishment.currencyCode,
  };
}
